import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useContext = () => {
  const { t } = useTranslation("dialogs");

  return useMemo(
    () => ({
      maxWidth: "49.5rem",
      title: t("editCoordinates.geometry"),
    }),
    [t],
  );
};
